<app-timebar [duration]="job().duration!" />
<app-audio-line [audio]="audio()" />
<app-transcription-segments-line [job]="job()!" [segments]="transcriptionSegments()"
    (segmentClick)="onActiveSegementChange.emit($event)" />